// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh2[data-v-7eced714] {\n  font-weight: bold;\n  cursor: pointer;\n}\nul[data-v-7eced714] {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.item[data-v-7eced714] {\n  padding: 10px;\n  border-bottom: 1px solid #DDE0E7;\n}\n", ""]);
// Exports
module.exports = exports;
